import { useState, useEffect } from "react";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import type { DevToolsPlugin, PluginStatus } from "../../types";
import { getCachedData, subscribe, fetchFlags } from "./store";
import { FeatureFlagsPanel } from "./FeatureFlagsPanel";

export function featureFlagsPlugin(): DevToolsPlugin {
  if (typeof document !== "undefined") fetchFlags();

  return {
    id: "feature-flags",
    name: "Feature Flags",
    icon: faFlag,
    render: () => <FeatureFlagsPanel />,
    useStatus: (): PluginStatus => {
      const [, forceUpdate] = useState(0);
      useEffect(() => subscribe(() => forceUpdate((n) => n + 1)), []);

      const data = getCachedData();
      if (!data) return { state: "loading" };
      const overrideCount = data.flags.filter((f) => f.overridden).length;
      if (overrideCount > 0) {
        return {
          state: "warning",
          badge: overrideCount,
          summary: `${overrideCount} flag override${overrideCount === 1 ? "" : "s"} active`,
        };
      }
      return { state: "inactive" };
    },
  };
}
